import { useTranslation } from 'next-i18next';
import { SpaceWithPlanDto } from '../../../../types/SubscriptionType';
import { PlanCardsList } from './organisms';

/**
 * 구독이 만료된 스페이스 리스트 컴포넌트
 * @description 구독이 만료된 스페이스 관련 데이터를 리스트래퍼 컴포넌트에 전달합니다.
 * 구독이 만료된 스페이스 관련 데이터들은 여기서 처리합니다.
 */
export const ExpiredSpaces = ({
  spaceList
}: {
  spaceList: SpaceWithPlanDto[];
}) => {
  const {
    t
  } = useTranslation(['subscription']);
  return <div data-sentry-component="ExpiredSpaces" data-sentry-source-file="ExpiredSpaces.tsx">
      <label className="color-gray-900 mb-[10px] text-subtitle font-semibold">
        {t('subscription:SpaceList.heading.planExpired')}
      </label>
      <hr className="m-0 h-px border-t-gray-300" />
      <PlanCardsList spaceList={spaceList} data-sentry-element="PlanCardsList" data-sentry-source-file="ExpiredSpaces.tsx" />
    </div>;
};